module.exports = __webpack_public_path__ + "img/SPONGEBOB-sample.9c7a31ca.gif";